var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "button",
      class: _vm.buttonClass,
      attrs: { href: _vm.href, disabled: _vm.disabled },
    },
    [
      _vm.icon
        ? _c("icon", { attrs: { name: _vm.icon, size: _vm.iconSize } })
        : _vm._e(),
      _c("span", [_vm._v(_vm._s(_vm.label))]),
      _c("span", [_vm._v(_vm._s(_vm.price))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }